'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Trigger, Close, Root, Content, Portal, Overlay } from './../../../external/@radix-ui/react-dialog/dist/index.js';
import { useState, useCallback } from 'react';
import { IconX } from '../../svg/icons/icon-x.js';
import { useMediaQuery, Breakpoints } from '../../util/use-media-query.js';
import { Button } from '../button/button.js';
import { ModalSizeToClass, ModalHeightToClass, ModalSize, ModalHeight } from './constants.js';
import { useModal } from './provider.js';
import { ButtonSize } from '../button/constants.js';

const Modal = ({ children, onOpenChange, ...props }) => {
    const { setOpen } = useModal();
    const handleOpenChange = onOpenChange || setOpen;
    return (jsx(Root, { onOpenChange: handleOpenChange, ...props, children: children }));
};
const useControlledModalState = () => {
    const [open, setOpen] = useState(false);
    const { setOpen: setGlobalOpen } = useModal();
    const handleOnOpenChange = useCallback((open) => {
        setOpen(open);
        setGlobalOpen(open);
    }, [setOpen, setGlobalOpen]);
    return [open, handleOnOpenChange];
};
const ModalTrigger = Trigger;
const ModalClose = Close;
const ModalContent = ({ size = ModalSize.MEDIUM, height = ModalHeight.AUTO, header, footer, hideCloseButton, children, preventCloseOnOverlayClick, preventScroll, useFullSpace, }) => {
    const isSm = useMediaQuery(Breakpoints.SM);
    const content = (jsxs(Content, { className: `fixed inset-y-0 left-0 w-full bg-white sm:relative sm:max-h-[90vh] ${useFullSpace ? '' : 'sm:w-auto '}sm:rounded-2xl md:min-w-100 ${ModalSizeToClass[size]} flex flex-col overflow-hidden ${ModalHeightToClass[height]}`, onPointerDownOutside: preventCloseOnOverlayClick ? (e) => e.preventDefault() : undefined, onEscapeKeyDown: preventCloseOnOverlayClick ? (e) => e.preventDefault() : undefined, onFocusCapture: (e) => {
            e.stopPropagation(); // prevent auto-focus of internal elements when the modal is opened
        }, children: [header ? (jsx("header", { className: "relative flex min-h-12 w-full shrink-0 items-center justify-center border-b border-b-leland-gray-stroke px-12 py-2 text-lg font-medium text-leland-gray-dark", children: header })) : null, hideCloseButton ? null : (jsx(Close, { className: "absolute right-2 top-2", children: jsx(Button, { label: "X", hideLabel: true, LeftIcon: IconX, size: ButtonSize.SMALL, rounded: true }) })), jsx("div", { className: `flex grow flex-col ${preventScroll ? 'overflow-hidden' : 'overflow-auto'}`, children: children }), footer ? (jsx("footer", { className: "shrink-0 border-t border-t-leland-gray-stroke p-4", children: footer })) : null] }));
    return (jsx(Portal, { children: isSm ? (jsx(Overlay, { className: "fixed left-0 top-0 flex size-full items-center justify-center bg-leland-gray-overlay px-8 py-[5%]", children: content })) : (content) }));
};

export { Modal, ModalClose, ModalContent, ModalTrigger, useControlledModalState };
//# sourceMappingURL=modal.js.map
